export function networkStatesReducer(prevState, actions) {
    switch (actions.type) {
        case 'UPDATE_NON_STATIC_CALLS_COUNT': {
            const newState = Object.assign({}, prevState);
            newState[actions.chainId] = Object.assign(Object.assign({}, newState[actions.chainId]), { nonStaticCalls: actions.count });
            return newState;
        }
        default:
            return prevState;
    }
}
//# sourceMappingURL=reducer.js.map